import { StateCreator } from 'zustand';

import { storeCreator } from '@/utils/store/store.utils';

const DEFAULT_STORE_KEY = 'useBadAddressReviewStore';

interface State {
  isModalVisible: boolean;

  handleOpenModal: () => void;
  handleCloseModal: () => void;
  handleReset: () => void;
}

const createBadAddressReviewStore = () => {
  const store: StateCreator<State> = (set) => ({
    isModalVisible: false,

    handleOpenModal: () => set((state) => ({ ...state, isModalVisible: true })),
    handleCloseModal: () => set((state) => ({ ...state, isModalVisible: false })),
    handleReset: () => set((state) => ({ ...state, isModalVisible: false })),
  });

  return storeCreator<State>(store);
};

const storeCache: { [key: string]: ReturnType<typeof createBadAddressReviewStore> } = {};

const useBadAddressReviewStore = (key = DEFAULT_STORE_KEY) => {
  if (!storeCache[key]) {
    storeCache[key] = createBadAddressReviewStore();
  }
  return storeCache[key]();
};

export const clearBadAddressReviewStore = (key = DEFAULT_STORE_KEY) => {
  delete storeCache[key];
};

export { useBadAddressReviewStore };

export default useBadAddressReviewStore;
